import { useTestOutgoingPostbackMutation } from "api/TenantSlug/OutgoingPostback/hooks";
import { BaseTestForm } from "components/Forms/BaseTestForm/BaseTestForm";
import { TestResult } from "components/Forms/BaseTestForm/TestResult";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { FormId } from "types/models";

import OutgoingPostbackData = App.Data.OutgoingPostbackData;

interface OutgoingPostbackTestFormProps {
    outgoingPostback: OutgoingPostbackData;
}

export const OutgoingPostbackTestForm: FC<OutgoingPostbackTestFormProps> = ({ outgoingPostback }) => {
    const { t } = usePaldockTranslation("forms.outgoing-postback-test");
    const testMut = useTestOutgoingPostbackMutation();

    const resetTest = () => {
        testMut.reset();
    };

    return (
        <BaseTestForm
            formId={FormId.OutgoingPostbackTestForm}
            entityId={outgoingPostback.id ?? ""}
            entityFilterKey="outgoing_postback_id"
            loadingMessage={t("messages.processing")}
            errorMessage={t("messages.test_failed")}
            stepValidationMessage={t("messages.select_first_step")}
            testMutation={{
                mutate: ({ first_step_id, query_values, header_values, body_values }, options) => {
                    testMut.mutate(
                        {
                            outgoingPostbackId: outgoingPostback.id ?? "",
                            request: { first_step_id, query_values, header_values, body_values },
                        },
                        options
                    );
                },
                isPending: testMut.isPending,
                isSuccess: testMut.isSuccess,
                isError: testMut.isError,
                error: testMut.error ? { message: testMut.error.message } : undefined,
                reset: testMut.reset,
            }}
            onTestSuccess={(series) => <TestResult series={series} resetTest={resetTest} />}
        />
    );
};